export default "__VITE_ASSET__BFLyvd8A__"